import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import licenseImage from '../assets/Certificates/License.jpeg';

function WhoWeAre() {
    const sectionRef = useRef(null);

    useEffect(() => {
        const observerOptions = {
            threshold: 0.1
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                }
            });
        }, observerOptions);

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => observer.disconnect();
    }, []);

    const whatWeDoItems = [
        { id: 1, title: ' Signage Design & Fabrication' },
        { id: 2, title: ' Branding Solutions' },
        { id: 3, title: ' Installation Services' },
        { id: 4, title: ' Repair & Maintenance' },
        { id: 5, title: ' Event & Exhibition Branding' }
    ];

    const modeOfWorkItems = [
        { id: 1, title: 'Consultation & Understanding', description: 'We listen to clients’ needs, brand identity, and project goals.' },
        { id: 2, title: 'Conceptual Design', description: 'Our creative team develops designs that align with brand aesthetics.' },
        { id: 3, title: 'Fabrication & Production', description: 'Using advanced machinery, durable materials, and skilled craftsmanship, we bring concepts to reality.' },
        { id: 4, title: 'Installation & Execution', description: 'Our professional installation team ensures safe, precise, and timely completion.' },
        { id: 5, title: 'After-Sales Support', description: 'We provide maintenance.' }
    ];

    return (
        <section className="who-we-are-section" id="about" ref={sectionRef}>
            <div className="container-wide">
                {/* WHO WE ARE */}
                <div className="who-we-are-grid">
                    <div className="who-we-are-image">
                        <img
                            src="https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=800&h=1000&fit=crop"
                            alt="Rainbow Craft Team"
                        />
                    </div>

                    <div className="who-we-are-content">
                        <h2 className="section-title-new">WHO WE ARE</h2>

                        <div className="who-we-are-text">
                            <p className="lead-text">
                                <strong>Rainbow Craft Signs & Graphics LLC</strong> is a dynamic and innovative company specializing
                                in designing, branding, signage manufacturing, and installation services.
                            </p>

                            <p>
                                Based in Abu Dhabi Musaffah, <strong>Rainbow Craft</strong> has built a strong reputation for delivering creative, high-quality,
                                and durable signage solutions that enhance brand visibility and create a lasting impression across all UAE.
                                From concept design to final installation, we provide end-to-end solutions for businesses
                                of all sizes, ensuring that every project reflects the unique identity of our clients.
                            </p>

                            <p>
                                At <strong>RainbowCraft</strong>, we specialize in LED and neon boards, 3D lettering, indoor & outdoor branding, wayfinding systems,
                                digital graphics, and customized signage solutions that combine creativity with functionality.
                                Our team of skilled designers, fabricators, and installers work with precision, passion, and
                                attention to detail to ensure exceptional outcomes on every project.
                            </p>

                            <Link to="/services" className="btn-text">
                                KNOW MORE <span>→</span>
                            </Link>
                        </div>
                    </div>
                </div>

                {/* WHAT WE DO */}
                <div style={{ marginTop: '120px' }}>
                    <div className="section-header-new">
                        <h2 className="section-title-new">WHAT WE DO</h2>
                    </div>

                    <p className="section-description" style={{ maxWidth: '800px', marginBottom: '50px', fontSize: '1.1rem', lineHeight: '1.8', opacity: '0.9' }}>
                        At Rainbow Craft Sign & Graphics LLC, we provide end-to-end signage and branding solutions that help
                        businesses stand out, connect with their audience, and strengthen their brand identity. Our expertise covers a
                        wide spectrum of services:
                    </p>

                    <div className="client-stats what-we-do-grid">
                        {whatWeDoItems.map((item) => (
                            <div key={item.id} className="stat-item">
                                <span className="stat-number" style={{ fontSize: '2rem', marginBottom: '15px', color: 'var(--primary-color)', fontFamily: 'var(--font-heading)', fontWeight: '700' }}>0{item.id}</span>
                                <span className="stat-label" style={{ fontSize: '0.8rem', letterSpacing: '1px', textTransform: 'uppercase', opacity: '1', color: 'var(--text-color)', fontWeight: '600' }}>{item.title}</span>
                            </div>
                        ))}
                    </div>

                    <div style={{ marginTop: '60px', maxWidth: '1000px', opacity: '0.9', lineHeight: '1.8', fontSize: '1.05rem' }}>
                        <p>
                            As a signage company, we also integrate branding solutions including illuminated
                            logos, vinyl graphics, 3D lettering, and LED lighting to create a striking visual impact.
                            Our team manages the entire process from design, fabrication, and installation to
                            ensure the podium reflects your brand identity while showcasing the vehicle in an
                            elegant and professional manner.
                        </p>
                    </div>
                </div>

                {/* MODE OF WORK */}
                <div style={{ marginTop: '120px' }}>
                    <div className="section-header-new">
                        <h2 className="section-title-new">MODE OF WORK</h2>
                    </div>

                    <p className="section-description" style={{ maxWidth: '800px', marginBottom: '50px', fontSize: '1.1rem', lineHeight: '1.8', opacity: '0.9' }}>
                        At Rainbow Craft, our process is systematic, collaborative, and customer-focused:
                    </p>

                    <div className="mode-of-work-grid">
                        {modeOfWorkItems.map((item) => (
                            <div key={item.id} className="mode-work-card">
                                <span className="mode-number">0{item.id}</span>
                                <h3 className="mode-title">{item.title}</h3>
                                <p className="mode-description">{item.description}</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* LICENSE */}
                <div style={{ marginTop: '120px' }}>
                    <div className="section-header-new">
                        <h2 className="section-title-new">OUR CERTIFICATES</h2>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-start', marginLeft: '70px' }}>
                        <img
                            src={licenseImage}
                            alt="License Certificate"
                            style={{ width: '250px', maxWidth: '100%', height: 'auto', borderRadius: '8px', boxShadow: '0 10px 10px rgba(0,0,0,0.1)' }}
                        />
                    </div>
                </div>

            </div>
        </section>
    );
}

export default WhoWeAre;
